import {analyticsApi, OtherApi} from "../../common/axios";
import { detect } from "detect-browser";

// 인증 관련 API
export const verifyAuthCode = async (code) => {
    try {
        return analyticsApi.post('/analyticsAuth', {code});
    } catch (error) {
        throw error;
    }
};

// 로그인 (ID/Password)
export const analyticsLogin = async (credentials) => {
    try {
        const browser = detect();
        const systemInfo = { browser, IPv4: null };
        try {
            const res = await OtherApi.get("https://api.ipify.org/?format=json");
            if (res.status === 200) systemInfo.IPv4 = res.data.ip;
        } catch (e) {
            // ignore ip fetch errors
        }

        const payload = { ...credentials, systemInfo };
        // 운영툴 로그인과 동일한 엔드포인트 사용 (분리된 포트/도메인)
        const { data } = await analyticsApi.post('analyticsAuth', payload);
        return data;
    } catch (error) {
        throw error;
    }
}

// 유저 통계 API
export const getUserStatistics = async (params) => {
    try {
        const queryString = new URLSearchParams(params).toString();
        const result = await analyticsApi.get(`/user/stats?${queryString}`);
        return result.data;
    } catch (error) {
        throw error;
    }
};

export const getUserChartData = async (params) => {
    try {
        const queryString = new URLSearchParams(params).toString();
        const result = await analyticsApi.get(`/user/chart?${queryString}`);
        return result.data;
    } catch (error) {
        throw error;
    }
};

// 매출 통계 API
export const getRevenueStatistics = async (params) => {
    try {
        const queryString = new URLSearchParams(params).toString();
        const result = await analyticsApi.get(`/revenue/stats?${queryString}`);
        return result.data;
    } catch (error) {

        throw error;
    }
};

export const getRevenueChartData = async (params) => {
    try {
        const queryString = new URLSearchParams(params).toString();
        const result = await analyticsApi.get(`/revenue/chart?${queryString}`);
        return result.data;
    } catch (error) {
        throw error;
    }
};

export const getTopProducts = async (params) => {
    try {
        const queryString = new URLSearchParams(params).toString();
        return analyticsApi.get(`/analytics/products/top?${queryString}`);
    } catch (error) {
        throw error;
    }
};

// 기타 유틸리티 함수들
export const formatNumber = (number) => {
    return new Intl.NumberFormat('ko-KR').format(number);
};

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
    }).format(amount);
};

export const calculateGrowthRate = (current, previous) => {
    if (previous === 0) return 0;
    return ((current - previous) / previous) * 100;
};
